import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { countries } from 'country-data-list';
import { Component } from 'react';
class CountrySelectField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasBlured: false,
        };
    }
    render() {
        const { name, displayName, hidden, disabled, required, input, meta, onChangeAction, className, } = this.props;
        let { placeholder } = this.props;
        let formGroupClasses = className && typeof className === 'string' ? className : '';
        let isDisabled = '';
        let validationErrors = null;
        let isRequired = null;
        if (meta.touched === true && meta.valid === true) {
            formGroupClasses += ' has-success';
        }
        else if (meta.touched === true && meta.error) {
            formGroupClasses += ' has-error';
            validationErrors = _jsx("span", Object.assign({ className: "validation-text" }, { children: meta.error }));
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (hidden === true) {
            formGroupClasses += ' hidden';
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (disabled === true) {
            formGroupClasses += ' disabled';
            isDisabled = 'diabled';
        }
        if (placeholder === null || placeholder === undefined) {
            placeholder = name + '...';
        }
        if (required === true) {
            isRequired = 'required';
        }
        const sortedCountries = countries.all.sort(function (a, b) {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
        });
        const ListCountries = (country) => {
            if (this.props.selected === country.alpha2) {
                return (_jsx("option", Object.assign({ value: country.alpha2, selected: true }, { children: country.name }), country.alpha2));
            }
            if (country.status === 'assigned') {
                return (_jsx("option", Object.assign({ value: country.alpha2 }, { children: country.name }), country.alpha2));
            }
            return null;
        };
        return (_jsxs("div", Object.assign({ className: 'form-group form-group-select' + formGroupClasses }, { children: [_jsxs("label", Object.assign({ className: "control-label", htmlFor: name }, { children: [displayName, " ", validationErrors] })), _jsxs("select", Object.assign({ value: input.value, onBlur: input.onBlur, onFocus: input.onFocus, onChange: (e) => {
                        if (typeof onChangeAction === 'function') {
                            onChangeAction(e.target.value);
                        }
                        input.onChange(e);
                    }, required: isRequired, id: name, disabled: isDisabled, className: "form-control" }, { children: [_jsx("option", Object.assign({ value: "" }, { children: " - No country selected" })), sortedCountries.map(ListCountries), this.props.children] }))] })));
    }
}
CountrySelectField.defaultProps = {
    disabled: false,
    hidden: false,
    required: false,
    showError: false,
};
export default CountrySelectField;
